// extracted by mini-css-extract-plugin
export default {"icon":"style_icon__tBUiY","dateContainer":"style_dateContainer__nkqwA"};